<template>
<div class="chapter">
<div class="inner_page">
<div class="halfTitlePage" id="hlf01">
<a id="page01">
<h2 class="halfTitlePageTitle"><span class="bold">BAIT</span></h2>
</a><a id="page02">
</a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781416995050_hlf01.vue?492ac51c